import * as React from 'react';
import { SVGProps } from 'react';
import styled from 'styled-components';

const SVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.756 2.312c.115.08.116.244.017.343l-5.84 5.858a.25.25 0 0 1-.353 0L1.734 2.662c-.1-.1-.098-.263.017-.344.285-.2.631-.318 1.006-.318h10c.374 0 .716.113.999.312Z"
      fill="currentColor"
    />
    <path
      d="M14.457 4.25a.05.05 0 0 1 .05.05v7.45a1.75 1.75 0 0 1-1.75 1.75h-10a1.75 1.75 0 0 1-1.75-1.75L1 4.293a.05.05 0 0 1 .05-.05h.102a.28.28 0 0 1 .153.078 2.815 2.815 0 0 0 .248.286l4.966 4.966a1.75 1.75 0 0 0 2.475 0l4.96-4.96a2.79 2.79 0 0 0 .248-.285.28.28 0 0 1 .153-.078h.102Z"
      fill="currentColor"
    />
  </svg>
);

const StyledSvgMail = styled(SVG)`
  font-size: ${props => (props.fontSize ? props.fontSize : '1.6rem')};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutralColors.charcoal};
  vertical-align: middle;
  shape-rendering: inherit;
  transform: translate3d(0, 0, 0);
`;
export default StyledSvgMail;
